( () => {
        "use strict";
		
        class search {
            constructor() { }
			
            static LOADER_ID = "searchLoader";
			static LOADER_DOC_ID = "searchLoaderDoc";
			static ERROR_ID = "searchErrorNotification";
			static ERROR_DOC_ID = "searchErrorDocNotification";
			static TAB_CLASS_0 = ".search-result-tab[data-tab-index=0]";
			static TAB_CLASS_1 = ".search-result-tab[data-tab-index=1]";
			
            showResults(json, query) {				
                let headingTemplate = '<h4 class="search-heading search-heading--bordered margin-t-3xl">{{results}}</h4>';
				let resultUlTemplate = '<ul class="list-no-style margin-t-l"></ul>';
				let resultCategoryTemplate = '<ul class="entry__category-list"><li class="entry__category-list-item">{{category}}</li></ul>';
				let resultTitleTemplate = '<h3 class="entry__headline cursor-pointer">{{title}}</h3>';
				let resultAbstractTemplate = '<p class="entry__paragraph cursor-pointer">{{image}}<span>{{abstract}}</span></p>';
				let resultLiTemplate = '<li><article class="entry">' + resultCategoryTemplate + resultTitleTemplate + resultAbstractTemplate + '<p></p></article></li>';
				let openMediaInBrowser = jQuery("#openMediaInBrowser").text();
				
				let hits = 0;
				let hitsDoc = 0;
				
				let searchResultUl = jQuery(resultUlTemplate);
				let searchResultDocUl = jQuery(resultUlTemplate);
				
				if (Array.isArray(json)) {
					json.forEach((hit => {
						let li = resultLiTemplate;
						li = li.replace(/{{title}}/ig, hit.title ? hit.title : "");
						li = li.replace(/{{image}}/ig, hit.image ? '<img class="entry__image" src="' + hit.image + '" alt="">' : "");
						li = li.replace(/{{abstract}}/ig, hit.abstractText ? hit.abstractText : "");
						li = li.replace(/{{category}}/ig, hit.category ? hit.category : "");
						
						if(hit.isMediaItem == true) {
							++hitsDoc;							
							let entryLinkDoc = jQuery(li).appendTo(searchResultDocUl);
							this.makeClickable(entryLinkDoc.find(".entry__paragraph"), hit.link, query, true, false, openMediaInBrowser);
							this.makeClickable(entryLinkDoc.find(".entry__headline"), hit.link, query, true, false, openMediaInBrowser);	
						} else {
							++hits;							
							let entryLink = jQuery(li).appendTo(searchResultUl);
							this.makeClickable(entryLink.find(".entry__paragraph"), hit.link, query, false, true, openMediaInBrowser);
							this.makeClickable(entryLink.find(".entry__headline"), hit.link, query, false, true, openMediaInBrowser);
						}
					}))
				}
				
				let results = hits + " " + (hits == 1 ? jQuery("#searchResultText").text() : jQuery("#searchResultsText").text());
				let resultsDoc = hitsDoc + " " + (hitsDoc == 1 ? jQuery("#searchResultText").text() : jQuery("#searchResultsText").text()); 				
				
				let heading = headingTemplate.replace(/{{results}}/ig, results);
				let headingDoc = headingTemplate.replace(/{{results}}/ig, resultsDoc);
				
                let searchResultHtml = jQuery(search.TAB_CLASS_0);
				let searchResultDocHtml = jQuery(search.TAB_CLASS_1);				
				
                jQuery(heading).appendTo(searchResultHtml);
				jQuery(headingDoc).appendTo(searchResultDocHtml);
				
                searchResultUl.appendTo(searchResultHtml);
				searchResultDocUl.appendTo(searchResultDocHtml);
            }
			
            executeSearchRequest(query) {
				let api = "/api/search";
				let site = llbPortal.site;
				let language = llbPortal.language;
             
				let apiQuery = document.location.origin + api + "?query=" + query + "&sc_lang=" + language + "&sc_site=" + site;
                
				this.showLoader(),
                
				this.getJson(apiQuery)
					.done((json => {
						jQuery("#search-info-box").slideUp("fast"),
						this.hideLoader(),
						this.showResults(json, query)
					}))
					.fail(( (api, error) => {
						this.hideLoader(),
						this.showError()
					}))
            }			
			resetResults() {
                jQuery(search.TAB_CLASS_0).html(this.loader(search.LOADER_ID));
				jQuery(search.TAB_CLASS_1).html(this.loader(search.LOADER_DOC_ID));
            }			
			searchOnServer(queryString) {
				this.resetResults();				
				if(queryString.length > 1) {					
					this.executeSearchRequest(queryString);
				}                
            }
            tabClicked(tabIndex) {
                this.tabButtons.removeClass("tab-header__button--active");
                jQuery(this.tabButtons[tabIndex]).addClass("tab-header__button--active");
                jQuery("button[data-modal-show='searchTabHeaderModal']").text(this.tabButtons[tabIndex].innerText);
                jQuery("#searchTabHeaderModal h1.pop-over__headline").text(this.tabButtons[tabIndex].innerText);
                jQuery(".search-container .search-result-tab").each(( (index, el) => {
                    let tab = jQuery(el);
                    this.show(tab.attr("data-tab-index") === "" + tabIndex, el)
                }
                ));
            }			
			initTabButtons() {
                this.tabButtons = jQuery(".search-container .tab-header__button:not(.tab-header__button--more)");
                this.tabButtons.each(( (tabIndex, el) => {
                    jQuery(el).on("click", ( () => {
                        this.tabClicked(tabIndex)
                    }
                    ))
                }
                ))
            }
            init() {
				this.initTabButtons();
                
				this.searchField = jQuery("#llbSearchField"),
                this.searchField.keyup(( () => {                    
                    clearTimeout(this.timeoutId),
                    this.timeoutId = window.setTimeout(( () => {
                        this.searchOnServer(this.searchField.val())
                    }
                    ), 1e3)
                }
                ))
            }
			getJson(apiQuery, appendData) {
				return jQuery.ajax(apiQuery, {
					cache: !1,
					error: (jqXHR, textStatus, errorThrown) => {
						if (null != jqXHR && 403 === jqXHR.status)
							console.info("User unauthenticated - issuing reload");
						else {
							let errorThrown = null != jqXHR ? jqXHR.status : "null";
							console.error('Http request failed, status: ' + errorThrown + ' - ' + textStatus)
						}
					},
					headers: { "X-Same-Domain": "1" },
					dataType: "json",
					data: appendData
				})
			}
			showLoader() {
                this.show(true, document.getElementById(search.LOADER_ID));
				this.show(true, document.getElementById(search.LOADER_DOC_ID));				
            }
            hideLoader() {
                this.show(false, document.getElementById(search.LOADER_ID));
				this.show(false, document.getElementById(search.LOADER_DOC_ID));
            }
            showError() {
				jQuery(search.TAB_CLASS_0).html(this.error(search.ERROR_ID));
                this.show(true, document.getElementById(search.ERROR_ID));
				jQuery(search.TAB_CLASS_1).html(this.error(search.ERROR_DOC_ID));
                this.show(true, document.getElementById(search.ERROR_DOC_ID));
            }			
			show(yes, el) {
                null == el || (yes ? (el.removeAttribute("hidden"),
                el.removeAttribute("aria-hidden")) : (el.setAttribute("hidden", ""),
                el.setAttribute("aria-hidden", "true")))
            }			
			loader(loaderId) {
				return '<div id="' + loaderId + '" class="loader centered margin-t-4xl" hidden="" aria-hidden="true"></div>'
			}
			error(errorId) {
				return '<article id="' + errorId + '" class="entry" hidden aria-hidden="true"><ul class="entry__category-list"><li class="entry__category-list-item"> </li></ul><p class="entry__paragraph"><span>' + jQuery("#searchGeneralErrorMessage").text() + '</span></p></article>';
			}			
            makeClickable(el, href, query, isMediaItem, scrollToText, openMediaInBrowser) {				
                el.on("click", ( () => {
					if(isMediaItem) {
						if(openMediaInBrowser == "yes") {
							let openInline = "openinline=true";
							let delimiter = (href.indexOf('?') > -1) ? "&" : "?";
							let mediaUrl = href + delimiter + openInline;	
							window.open(mediaUrl, "_blank");
						} else {
							window.location.href = href;
						}
					} else {					
						let scrollToTextAdd = "";
						if(scrollToText) {
							scrollToTextAdd = "#:~:text=" + query;
						}					
						window.location.href = href + scrollToTextAdd;			
					}						
                }))                
            }			
        }	
		(new search).init();		
    }
)();
